import type { ComponentType } from 'react';

// Lazily load a page, which breaks up the app into chunks
export function lazyPage<M, K extends keyof M>(load: () => Promise<M>, name: K) {
    return async () => ({ Component: (await load())[name] as ComponentType });
}
